import pc from 'prefix-classnames';

const px = pc('KnowzUI');

export default px;
